import { BackButton } from '@/components/web-back-button'

interface Props {
  title: string
  showBackButton?: boolean
}

export const SchoolAdminPageHeroBanner = ({
  title,
  showBackButton = true,
}: Props): JSX.Element => {
  return (
    <section className="flex h-[100px] items-center justify-center bg-primary-75 px-6">
      {showBackButton ? (
        <BackButton className="relative" />
      ) : (
        <div className="w-[90px]" />
      )}
      <h2 className="flex-1 text-center text-[32px] font-bold text-white">
        {title}
      </h2>
      <div className="w-[90px]"></div>
    </section>
  )
}
